export default __webpack_public_path__ + "static/media/smellCoffee.3b0486e7.jpg";